import styled from "styled-components";

export const InfoContainer = styled.div`
  display: grid;
  place-items: center;
  gap: 1rem;
  padding: 1rem;
`;

export const IconeContainer = styled.div`
  padding: 0.75rem 1rem;
  background-color: #FFEFCC;
  border-radius: 0.5rem;
  svg {
    color: #FF9F42;
  }
`;

export const TextContainer = styled.div`
  display: grid;
  place-items: center;
`
